export default __webpack_public_path__ + "static/media/REACT.b09cea7b.png";